import OrgChart from './OrgChart';

export default OrgChart;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/actorsHandler/orgChart/index.js